// extracted by mini-css-extract-plugin
export default {"textContainer":"TribesDetails_textContainer__s14YE","tribeDescription":"TribesDetails_tribeDescription__NvKca"};